export default __webpack_public_path__ + "static/media/gallery_02@2x.ae3419cc.jpg";